import React, { useRef, useState } from "react";
import CircularLoader from "../../assets/images/icons/circular-spinner.svg";
import CancelIcon from "../../assets/images/icons/cancel-icon.svg";
import { connect } from "react-redux";
import { invoiceCreationService } from "../../_services/invoiceCreation.service";
import { alertActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { debounce } from "lodash";
import FullScreenModal from "../../components/FullScreenModal";
import { Label } from "reactstrap";
import { store } from "react-notifications-component";

const OtpModal = (props) => {
  const {
    dispatch,
    validateNin,
    setShowOtpModal,
    invoiceCustomerData,
    setInvoiceCustomerData,
    setIsOtpValid,
    ninInfo,
    showOtpModal,
  } = props;
  const [otp, setOtp] = useState(null);
  const [validatingOtp, setValidatingOtp] = useState(false);
  const validatingOtpRef = useRef(null);

  const handleOtp = (e) => {
    let otpValue = e.target.value;

    // Only allow numeric input and trim to max 6 digits
    otpValue = otpValue.replace(/\D/g, "").slice(0, 6); // only digits, max 6
    setOtp(otpValue);

    if (otpValue.length === 6) {
      setValidatingOtp(true);
      validateOtp(otpValue);
    } else {
      validateOtp.cancel(); // cancel debounce if user deletes characters
      setValidatingOtp(false);
    }
  };

  const validateOtp = debounce((otpValue) => {
    const payload = {
      // TODO: remove the hardcoded values - nin
      nin: invoiceCustomerData.nin,
      // TODO: remove the hardcoded value for phone to ninInfo?.mobile
      phone: "2348023786842",
      otp: otpValue,
    };
    dispatch(alertActions.startRequest());

    const currentRequest = invoiceCreationService.validateOtp(payload);
    validatingOtpRef.current = currentRequest;

    currentRequest.then((res) => {
      dispatch(alertActions.stopRequest());
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        if (ninInfo) {
          const {
            firstName,
            middleName,
            lastName,
            mobile,
            email,
            address,
            gender,
            country,
          } = ninInfo;

          const fullName = [firstName, middleName, lastName]
            .filter(Boolean)
            .join(" ");
          const formattedAddress = [
            address?.addressLine,
            address?.town,
            address?.lga,
            address?.state,
            country,
          ]
            .filter(Boolean)
            .join(", ");
          const formattedGender =
            gender?.toLowerCase() === "f" ? "Female" : "Male";

          setInvoiceCustomerData((prev) => ({
            ...prev,
            customerName: fullName || ninInfo.name || null,
            phone: mobile || null,
            email: email || null,
            address: formattedAddress || null,
            gender: formattedGender || null,
          }));
        }
        store.addNotification({
          title: "Success",
          message:
            res?.response?.message ||
            "OTP verification successful. You can now proceed to complete your invoice creation",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 5000 },
        });
        setShowOtpModal(false);
        setIsOtpValid(true);
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        setValidatingOtp(false);
        store.addNotification({
          title: "Error",
          message: res?.response?.message || "Error validating OTP",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });
        setIsOtpValid(false);
      }
    });
  }, 500); // runs after 500ms of no typing

  return (
    <FullScreenModal
      show={showOtpModal}
      zIndex={100}
      callback={() => setShowOtpModal(true)}
    >
      <div className="otp-modal-container">
        <div className="header">
          <p className="title">6 digit pin</p>
          <button
            onClick={() => setShowOtpModal(false)}
            className="close-button"
          >
            <img src={CancelIcon} alt="close icon" />
          </button>
        </div>
        <p className="pin-instruction">
          NIN Validated! Input OTP sent to your number linked to your NIN (
          {invoiceCustomerData?.nin || "------"})
        </p>
        <div>
          <Label className="entity-auth-label">OTP</Label>
          <div className="input-container">
            <input
              className="no-spinner-input entity-auth-label-dropdown"
              type="text"
              name="otp"
              value={otp}
              onChange={handleOtp}
              maxLength={6}
              inputMode="numeric"
              pattern="\d*"
              disabled={validatingOtp}
            />
            {validatingOtp && (
              <img
                src={CircularLoader}
                alt="loader icon"
                className={`activity-icon loading`}
              />
            )}
          </div>
          <p className="modal-resend-text">
            Didn’t get OTP?{" "}
            <span onClick={() => validateNin(invoiceCustomerData?.nin)}>
              Retry
            </span>
          </p>
        </div>
      </div>
    </FullScreenModal>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(OtpModal);
